import { BonusPaymentModalAction, BonusPaymentModalState } from "./modals.bonusPayment.types";

export const bonusPaymentModalSetAction = (modal: Partial<BonusPaymentModalState>): BonusPaymentModalAction => ({ type: 'BONUS_PAYMENT_MODAL_SET', params: modal })

export const bonusPaymentModalCloseAction = (): BonusPaymentModalAction => ({ type: 'BONUS_PAYMENT_MODAL_CLOSE' })

export const bonusPaymentModalOpenAction = (): BonusPaymentModalAction => ({ type: 'BONUS_PAYMENT_MODAL_OPEN' })